import { useEffect } from 'react';
import { loadScript } from '@golden/shared';
export const registerGA = (id) => {
    if (!document || !window)
        return;
    if (!window.gtag) {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
        };
    }
    window.gtag('js', new Date());
    const resource = `https://www.googletagmanager.com/gtag/js?id=${id}&l=dataLayer`;
    void loadScript(resource);
};
export const usePageview = (gaId) => {
    useEffect(() => {
        if (!window.gtag)
            return;
        window.gtag('config', gaId, { page_title: document.title, page_path: window.location.pathname + window.location.search });
    }, []);
};
//# sourceMappingURL=registerGA.js.map